module.exports = __webpack_public_path__ + "static/media/program-antyplagiatowy-wrona-5.483c64bb.png";